export const groups = [
  {
    key: 'quick',
    label: 'Quick Comparison',
    headers: [
      'Fund Name',
      'Fund Category',
      'Fund Sub-Category',
      'Change in NAV',
      '5 Yr Return',
      'AMC',
      'Risk',
    ],
  },
  {
    key: 'details',
    label: 'Fund Details',
    headers: [
      'Fund Name',
      'NAV',
      'Exit Load',
      'Expense Ratio',
      'AUM',
      'Launch Date',
      'Type',
    ],
  },
  {
    key: 'returns',
    label: 'Returns',
    headers: [
      'Fund Name',
      '10 year',
      '5 year',
      '3 year',
      '1 year',
      '6 month',
      '3 month',
      '1 week',
      '1 day',
    ],
  },
  {
    key: 'other',
    label: 'Risk & Ratios',
    headers: [
      'Fund Name',
      'Alpha (5 year)',
      'Beta (5 year)',
      'Standard Deviation (5 year)',
      'Rsquared (5 year)',
    ],
  },
];



// WEBPACK FOOTER //
// ./constants/fundComparision.ts